import React, { useState, ChangeEvent } from 'react';
import {Modal, Layout, Menu, Tooltip} from 'antd';
import {
    CalculatorOutlined,
    ClockCircleOutlined,
    FontSizeOutlined,
    FunctionOutlined, InfoCircleOutlined
} from '@ant-design/icons';
import ArithmeticFunctions from "./functions/ArithmeticFunctions";
import DateFunctions from "./functions/DateFunctions";
import StringFunctions from "./functions/StringFunctions";
import PasswordFunctions from "./functions/PasswordFunctions";

const { Sider, Content } = Layout;

interface ExpressionBuilderModalProps {
    isVisible: boolean;
    handleCancel: () => void;
    onSave: (expression: string) => void;
    thisOption?: boolean;
}

const ExpressionBuilderModal: React.FC<ExpressionBuilderModalProps> = ({ isVisible, handleCancel, onSave, thisOption}) => {
    const [selectedFunction, setSelectedFunction] = useState<string | null>(null);

    const handleMenuClick = (e: any) => {
        setSelectedFunction(e.key);
    };

    const handleSave = (expression: string) => {
        onSave(expression);
        handleCancel();
    };

    const menuItems = [
        {
            key: 'arithmetische-operationen',
            type: 'group',
            label: 'Arithmetische Operationen',
            children: [
                {
                    key: 'add',
                    icon: <CalculatorOutlined />,
                    label: 'Addieren',
                },
                {
                    key: 'subtract',
                    icon: <CalculatorOutlined />,
                    label: 'Subtrahieren',
                },
                {
                    key: 'multiply',
                    icon: <CalculatorOutlined />,
                    label: 'Multiplizieren',
                },
                {
                    key: 'divide',
                    icon: <CalculatorOutlined />,
                    label: 'Dividieren',
                },
            ],
        },
        {
            key: 'datum-und-zeitfunktionen',
            type: 'group',
            label: 'Datum- und Zeitfunktionen',
            children: [
                {
                    key: 'dateTime',
                    icon: <ClockCircleOutlined />,
                    label: 'Datum-Zeit-Offset',
                },
            ],
        },
        {
            key: 'string-operationen',
            type: 'group',
            label: 'String-Operationen',
            children: [
                {
                    key: 'concat',
                    icon: <FontSizeOutlined />,
                    label: 'Verketten',
                },
                {
                    key: 'substring',
                    icon: <FontSizeOutlined />,
                    label: 'Teilstring',
                },
                {
                    key: 'split',
                    icon: <FontSizeOutlined />,
                    label: 'Trennen',
                },
            ],
        },
        {
            key: 'password-funktion',
            type: 'group',
            label: 'Passwörter',
            children: [
                {
                    key: 'password',
                    icon: <FunctionOutlined />,
                    label: 'Passwörter',
                },
            ],
        },
        {
            key: 'benutzerdefinierte-funktionen',
            type: 'group',
            label: 'Benutzerdefinierte Funktionen',
            children: [
                {
                    key: 'customFunction',
                    icon: <FunctionOutlined />,
                    label: 'Benutzerdefiniert',
                },
            ],
        },
    ];

    const variable = '{this}'

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Ausdruck erstellen</span>
                    {thisOption && (
                        <div style={{ display: 'flex', alignItems: 'center', color: '#1890ff', marginLeft: '20px', backgroundColor: '#e6f7ff', padding: '4px 8px', borderRadius: '4px', marginRight: 25 }}>
                            <InfoCircleOutlined style={{ marginRight: 8 }} />
                            <span style={{ fontSize: '14px' }}>Verwende {variable}, um eine Funktion auf die lokalisierte Variable anzuwenden, bevor sie gespeichert wird.</span>
                        </div>
                    )}
                </div>
            }
            open={isVisible}
            onCancel={handleCancel}
            footer={null}
            width={800}
        >
            <Layout style={{ height: '100%' }}>
                <Sider width={200} className="site-layout-background">
                    <Menu
                        mode="inline"
                        style={{ height: '100%', borderRight: 0 }}
                        onClick={handleMenuClick}
                        items={menuItems}
                    />
                </Sider>
                <Layout style={{ padding: '0 24px 24px', flex: 1 }}>
                    <Content style={{ padding: 24, margin: 0, minHeight: 280 }}>
                        {selectedFunction && (
                            <>
                                {['add', 'subtract', 'multiply', 'divide'].includes(selectedFunction) && (
                                    <ArithmeticFunctions selectedFunction={selectedFunction} onSave={handleSave} />
                                )}
                                {['dateTime'].includes(selectedFunction) && (
                                    <DateFunctions selectedFunction={selectedFunction} onSave={handleSave} />
                                )}
                                {['concat', 'substring', 'split'].includes(selectedFunction) && (
                                    <StringFunctions selectedFunction={selectedFunction} onSave={handleSave} />
                                )}
                                {['password'].includes(selectedFunction) && (
                                    <PasswordFunctions onSave={handleSave} />
                                )}
                            </>
                        )}
                    </Content>
                </Layout>
            </Layout>
        </Modal>
    );
};

export default ExpressionBuilderModal;
